import common from './common.json';
import plan from './plan.json';
import confirm from './confirm.json';
import account from './account.json';
import payment from './payment.json';
import done from './done.json';

export default {
  common,
  plan,
  confirm,
  account,
  payment,
  done,
};
